import { render, staticRenderFns } from "./storyItem.vue?vue&type=template&id=3fb9b343&scoped=true&"
import script from "./storyItem.vue?vue&type=script&lang=ts&"
export * from "./storyItem.vue?vue&type=script&lang=ts&"
import style0 from "./storyItem.vue?vue&type=style&index=0&id=3fb9b343&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb9b343",
  null
  
)

export default component.exports